import { Link } from "react-router-dom";

const stats = [
  { value: "10 万+", label: "在线视频" },
  { value: "8 大", label: "内容分类" },
  { value: "4K", label: "高清画质" },
  { value: "每日", label: "持续更新" },
];

export default function AboutIntro() {
  return (
    <section className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="grid gap-0 lg:grid-cols-2">
        <div className="flex flex-col justify-center gap-5 p-6 md:p-10">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-emotion-happy-line"></i>
            关于啪啪视频
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一个为好内容而生的高清视频分享平台
          </h2>
          <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
            啪啪视频汇聚娱乐、生活、教育、科技、音乐、体育、美食与旅行等多类别视频资源。我们希望用清晰细致的分类与贴心的推荐，让每一个打开网站的人都能快速找到想看的内容，也让有想法的创作者被更多人看见。
          </p>
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label} className="rounded-lg bg-background-100 px-3 py-3 text-center">
                <p className="font-heading text-lg font-bold text-primary-600">{item.value}</p>
                <p className="mt-0.5 text-xs text-foreground-500">{item.label}</p>
              </div>
            ))}
          </div>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/about"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
            >
              了解更多
            </Link>
            <Link
              to="/contact"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600"
            >
              联系我们
            </Link>
          </div>
        </div>
        <div className="relative min-h-[240px] lg:min-h-full">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20video%20streaming%20studio%20interior%20with%20large%20screens%20and%20warm%20ambient%20lighting%2C%20clean%20minimal%20workspace%2C%20soft%20natural%20light%2C%20ultra%20detailed%2C%20professional%20editorial%20photography&width=1000&height=900&seq=pp-about-01&orientation=squarish"
            alt="啪啪视频内容创作空间"
            title="啪啪视频 - 高清在线视频分享平台"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/20 to-transparent lg:from-background-50"></div>
        </div>
      </div>
    </section>
  );
}